// Display title of a live / replay. A host who typed no title gets the translated
// « {name} est en direct » (ongoing) or « {name} était en direct » (ended) formula —
// both editable in Admin › Traductions (live.title_live / live.title_replay).

export const fillName = (tpl, name) => String(tpl || "").replace(/\{name\}/g, name || "").trim();

export const liveHasEnded = (l) => !!l && (l.status === "ended" || (!l.is_live && l.status !== "live" && l.status !== "waiting" && !!(l.replay_url || l.replay_post_id)));

export function liveTitle(l, t, opts = {}) {
  const custom = String(l?.title || "").trim();
  if (custom) return custom;
  const name = opts.name || l?.church_name || l?.host?.name || l?.host_name || "";
  const ended = typeof opts.ended === "boolean" ? opts.ended : liveHasEnded(l);
  return ended
    ? fillName(t("live.title_replay", "{name} était en direct"), name)
    : fillName(t("live.title_live", "{name} est en direct"), name);
}
